import React from 'react';
import { useDispatch } from 'react-redux';
import { signOut } from '../../redux/auth';

const Logout = () => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    const performSignOut = async () => {
      await dispatch(signOut());
    };
    performSignOut();
  }, [dispatch]);

  return null;
};

export default Logout;
